<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">อัปเดตบัตรแบบกลุ่ม</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        เลือกบัตรจากตารางหรือ Excel แล้วกดแก้ไขทั้งหมดที่เลือก — เปลี่ยนวันที่ / Subscription / Client ได้พร้อมกัน
      </p>
      <div class="flex flex-wrap items-center gap-2 mt-3">
        <span *ngIf="siteState.selectedSite()?.name"
          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
          <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
        </span>
        <span
          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-sky-50 dark:bg-sky-900/20 text-sky-700 dark:text-sky-300 text-xs font-bold">
          <span class="material-icons text-[14px]">sync</span>
          หากลานเปิด taiwan_site — เมื่อแก้วันที่ระบบจะ sync ไป Taiwan ให้
        </span>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center self-start">
      <span class="text-xs text-slate-400 whitespace-nowrap self-center">
        ดึงข้อมูลล่าสุด:
        <strong class="text-slate-600 dark:text-slate-300">
          {{ lastFetchedAt ? (lastFetchedAt | date:'HH:mm:ss') : 'ยังไม่ได้ดึงข้อมูล' }}
        </strong>
      </span>
      <button (click)="onRefresh()" title="ดึงข้อมูล"
        class="px-4 py-3 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons">refresh</span>
        <span class="font-bold">ดึงข้อมูล</span>
      </button>
    </div>
  </div>

  <!-- Excel tools -->
  <div class="animate-fade-in mb-6 rounded-[2rem] border border-slate-100/50 dark:border-slate-700/50 bg-white/95 dark:bg-slate-800/95 p-6 shadow-[0_20px_50px_rgba(0,0,0,0.04)]">
    <div class="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-4">
      <div>
        <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">upload_file</span>
          เครื่องมือ Excel
        </h2>
        <p class="text-xs text-slate-400 mt-1 font-medium">
          อัปโหลดคอลัมน์ <code class="font-mono">ทะเบียน</code> (ไม่ต้องรู้ประเภทรถ) — ถ้าทะเบียนซ้ำข้ามประเภท ระบบแยกผลให้ · คอลัมน์ <code class="font-mono">vehicle_type</code> ใส่หรือไม่ใส่ก็ได้
        </p>
      </div>
      <div class="flex flex-wrap items-center gap-3">
        <button type="button" (click)="downloadSampleExcel()"
          title="ดาวน์โหลดไฟล์ Excel ตัวอย่าง"
          class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-bold cursor-pointer hover:text-amber-500 hover:border-amber-300 transition-all inline-flex items-center gap-2">
          <span class="material-icons text-[18px]">download</span>
          Excel ตัวอย่าง
        </button>
        <label class="px-4 py-2.5 rounded-xl bg-slate-800 dark:bg-amber-500 text-white dark:text-slate-900 font-bold cursor-pointer hover:opacity-90 transition-all inline-flex items-center gap-2">
          <span class="material-icons text-[18px]">attach_file</span>
          เลือกไฟล์ Excel
          <input type="file" accept=".xlsx,.xls,.csv" class="hidden" (change)="onExcelSelected($event)" />
        </label>
        <button *ngIf="hasExcelLookup" type="button" (click)="clearExcelLookup()"
          class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold cursor-pointer">
          ล้างผลค้นหา
        </button>
      </div>
    </div>

    <div *ngIf="excelFileName" class="mb-4 text-xs font-bold text-slate-500">
      ไฟล์: <span class="text-slate-700 dark:text-slate-200">{{ excelFileName }}</span>
      · อ่านได้ {{ excelLicenseItems.length | number }} ทะเบียน
    </div>

    <div *ngIf="hasExcelLookup" class="space-y-5">
      <div class="flex flex-wrap items-center gap-2">
        <span class="px-2.5 py-1 rounded-full bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300 text-xs font-bold">
          เจอ {{ lookupFound.length | number }}
        </span>
        <span class="px-2.5 py-1 rounded-full bg-rose-50 dark:bg-rose-900/20 text-rose-700 dark:text-rose-300 text-xs font-bold">
          ไม่เจอ {{ lookupNotFound.length | number }}
        </span>
        <span class="text-xs text-slate-400 font-medium">ผลค้นหาแยกตามประเภทรถ — แก้ไขทีละกลุ่มได้จากหัวข้อแต่ละกลุ่ม</span>
      </div>

      <div *ngIf="lookupFound.length > 0" class="space-y-4">
        <div class="flex flex-wrap items-center justify-between gap-2 px-1">
          <span class="text-sm font-bold text-emerald-800 dark:text-emerald-300">ทะเบียนที่พบในระบบ ({{ lookupFound.length }} บัตร)</span>
          <label class="inline-flex items-center gap-2 text-xs font-bold cursor-pointer">
            <input type="checkbox" [checked]="allExcelFoundSelected"
              (change)="toggleSelectAllExcel(($any($event.target)).checked)"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 cursor-pointer" />
            เลือกทั้งหมดที่พบ
          </label>
        </div>

        <div *ngFor="let group of lookupFoundGroups"
          class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-700">
          <div class="px-4 py-3 bg-slate-50 dark:bg-slate-900/60 border-b border-slate-100 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
            <div class="flex flex-wrap items-center gap-2">
              <span class="material-icons text-amber-500 text-[20px]">directions_car</span>
              <span class="font-extrabold text-slate-800 dark:text-slate-100">{{ group.vehicleTypeName }}</span>
              <span class="px-2 py-0.5 rounded-full bg-white dark:bg-slate-800 text-xs font-bold text-slate-500">{{ group.rows.length }} ใบ</span>
              <label class="inline-flex items-center gap-1.5 text-xs font-bold cursor-pointer ml-1">
                <input type="checkbox" [checked]="isGroupAllSelected(group)"
                  (change)="toggleSelectGroup(group, ($any($event.target)).checked)"
                  class="w-4 h-4 rounded border-slate-300 text-amber-500 cursor-pointer" />
                เลือกกลุ่มนี้
              </label>
            </div>
            <div *ngIf="canUpdate" class="flex flex-wrap gap-2">
              <button type="button" (click)="openEditModalForGroup('dates', group)" [disabled]="isSaving"
                class="px-3 py-1.5 rounded-lg border border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-300 text-xs font-bold cursor-pointer">แก้วันที่</button>
              <button type="button" (click)="openEditModalForGroup('subscription', group)" [disabled]="isSaving"
                class="px-3 py-1.5 rounded-lg border border-sky-200 dark:border-sky-800 text-sky-800 dark:text-sky-300 text-xs font-bold cursor-pointer">แก้ Subscription</button>
              <button type="button" (click)="openEditModalForGroup('client', group)" [disabled]="isSaving"
                class="px-3 py-1.5 rounded-lg border border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-300 text-xs font-bold cursor-pointer">แก้ Client</button>
            </div>
          </div>
          <table class="w-full text-left border-collapse text-xs min-w-[760px]">
            <thead>
              <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                <th class="p-3 w-12"></th>
                <th class="p-3">จาก Excel</th>
                <th class="p-3">ทะเบียนในระบบ</th>
                <th class="p-3">บัตร</th>
                <th class="p-3">Client</th>
                <th class="p-3">Subscription</th>
                <th class="p-3">สถานะ</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
              <tr *ngFor="let row of group.rows; trackBy: trackByCardId" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40">
                <td class="p-3">
                  <input type="checkbox" [checked]="isSelected(row.cardId)"
                    (change)="toggleRow(row.cardId, ($any($event.target)).checked)"
                    class="w-4 h-4 rounded border-slate-300 text-amber-500 cursor-pointer" />
                </td>
                <td class="p-3 font-mono">{{ row.inputLicense }}</td>
                <td class="p-3 font-mono font-bold">{{ row.plateNumber }}</td>
                <td class="p-3">
                  <div class="font-bold text-slate-700 dark:text-slate-200">{{ row.cardName || '—' }}</div>
                  <div class="text-[11px] text-slate-400 font-mono">#{{ row.cardId }} · {{ row.cardCode || '—' }}</div>
                </td>
                <td class="p-3">{{ row.clientName || '—' }}</td>
                <td class="p-3">{{ row.subscriptionName || '—' }}</td>
                <td class="p-3">{{ getStatusText(row.status) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngIf="lookupNotFound.length > 0" class="overflow-x-auto rounded-2xl border border-rose-100 dark:border-rose-900/40">
        <div class="px-4 py-2.5 bg-rose-50/80 dark:bg-rose-950/20 border-b border-rose-100 dark:border-rose-900/40 font-bold text-rose-800 dark:text-rose-300 text-sm flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <span>ไม่พบในระบบ — ให้ไปเพิ่มบัตรเอง</span>
          <button type="button" (click)="downloadNotFoundExcel()"
            class="px-3 py-1.5 rounded-lg bg-white dark:bg-slate-800 border border-rose-200 dark:border-rose-800 text-rose-700 dark:text-rose-300 text-xs font-bold cursor-pointer inline-flex items-center gap-1.5 self-start sm:self-auto">
            <span class="material-icons text-[16px]">download</span>
            โหลดทะเบียนที่ไม่พบ ({{ lookupNotFound.length }})
          </button>
        </div>
        <table class="w-full text-left border-collapse text-xs">
          <thead>
            <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
              <th class="p-3">ทะเบียนจาก Excel</th>
              <th class="p-3">vehicle_type</th>
              <th class="p-3">หลังตัดช่องว่าง</th>
              <th class="p-3">เหตุผล</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let n of lookupNotFound" class="border-t border-rose-50 dark:border-rose-900/30">
              <td class="p-3 font-mono">{{ n.inputLicense }}</td>
              <td class="p-3">{{ n.vehicleTypeName || '—' }}</td>
              <td class="p-3 font-mono text-slate-500">{{ n.normalizedLicense }}</td>
              <td class="p-3 text-slate-500 text-[11px]">{{ n.reason || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Search & filters + table -->
  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">filter_list</span>
          ค้นหาและกรอง
        </h2>
        <div *ngIf="selectedCount > 0" class="flex flex-wrap items-center gap-2">
          <span class="text-xs font-bold text-slate-500">เลือกแล้ว {{ selectedCount | number }} ใบ</span>
          <button type="button" (click)="clearSelection()"
            class="px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 text-xs font-bold cursor-pointer">
            ล้างการเลือก
          </button>
          <ng-container *ngIf="canUpdate">
            <button type="button" (click)="openEditModal('dates')" [disabled]="isSaving"
              class="px-3 py-2 rounded-xl border border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-300 text-xs font-bold cursor-pointer inline-flex items-center gap-1">
              <span class="material-icons text-[16px]">event</span> แก้วันที่
            </button>
            <button type="button" (click)="openEditModal('subscription')" [disabled]="isSaving"
              class="px-3 py-2 rounded-xl border border-sky-200 dark:border-sky-800 text-sky-800 dark:text-sky-300 text-xs font-bold cursor-pointer inline-flex items-center gap-1">
              <span class="material-icons text-[16px]">card_membership</span> แก้ Subscription
            </button>
            <button type="button" (click)="openEditModal('client')" [disabled]="isSaving"
              class="px-3 py-2 rounded-xl border border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-300 text-xs font-bold cursor-pointer inline-flex items-center gap-1">
              <span class="material-icons text-[16px]">business</span> แก้ Client
            </button>
          </ng-container>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-1 p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-auto min-h-[46px] shadow-sm">
        <button type="button" (click)="setFilterStatus(0)"
          class="px-3 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
          [ngClass]="filterStatus === 0 ? 'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-100 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600'">
          ทั้งหมด
        </button>
        <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-0.5"></div>
        <button type="button" (click)="setFilterStatus(1)"
          class="px-3 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
          [ngClass]="filterStatus === 1 ? 'bg-white dark:bg-slate-700 text-green-600 dark:text-green-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-green-600 dark:hover:text-green-400'">
          ใช้งานอยู่
        </button>
        <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-0.5"></div>
        <button type="button" (click)="setFilterStatus(2)"
          class="px-3 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
          [ngClass]="filterStatus === 2 ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400'">
          หมดอายุ
        </button>
      </div>

      <div class="flex flex-col lg:flex-row lg:items-end gap-3">
        <div class="w-full lg:w-64 xl:w-72">
          <label class="block text-xs font-bold text-slate-500 mb-1.5">กรองประเภทรถ</label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">directions_car</span>
            <input type="text" [(ngModel)]="vehicleTypeSearchText" (focus)="isVehicleTypeDropdownOpen = true"
              (ngModelChange)="isVehicleTypeDropdownOpen = true"
              placeholder="ค้นหาประเภทรถ..."
              class="w-full pl-10 pr-4 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
            <div *ngIf="isVehicleTypeDropdownOpen"
              class="absolute z-30 mt-1 w-full max-h-56 overflow-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg"
              (mousedown)="$event.preventDefault()">
              <button type="button" (click)="clearVehicleTypeFilter()"
                class="w-full text-left px-4 py-2 text-xs font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer">ทั้งหมด</button>
              <button type="button" *ngFor="let v of vehicleTypeFilterOptions" (click)="selectVehicleType(v)"
                class="w-full text-left px-4 py-2 text-sm hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer">{{ v.typeName }}</button>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-80 xl:w-96">
          <label class="block text-xs font-bold text-slate-500 mb-1.5">กรองลูกค้า</label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">person_search</span>
            <input type="text" [(ngModel)]="clientSearchText" (focus)="isClientDropdownOpen = true"
              (ngModelChange)="isClientDropdownOpen = true"
              placeholder="ค้นหาหรือเลือกลูกค้า..."
              class="w-full pl-10 pr-4 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
            <div *ngIf="isClientDropdownOpen"
              class="absolute z-30 mt-1 w-full max-h-56 overflow-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg"
              (mousedown)="$event.preventDefault()">
              <button type="button" (click)="clearClientFilter()"
                class="w-full text-left px-4 py-2 text-xs font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer">ทั้งหมด</button>
              <button type="button" *ngFor="let c of clientFilterOptions" (click)="selectClient(c)"
                class="w-full text-left px-4 py-2 text-sm hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer">{{ c.name }}</button>
            </div>
          </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-3 flex-1 lg:justify-end">
          <select [(ngModel)]="searchType"
            class="bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl px-3 py-2.5 text-sm font-bold outline-none focus:ring-2 focus:ring-amber-200 shrink-0">
            <option value="card_name">หมายเลขบัตร</option>
            <option value="license">ทะเบียน</option>
          </select>

          <div class="relative w-full sm:w-56 lg:w-64">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()"
              [placeholder]="searchType === 'license' ? 'ค้นหาทะเบียน...' : 'ค้นหาหมายเลขบัตร...'"
              class="w-full pl-10 pr-4 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <button type="button" (click)="onSearch()"
            class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold cursor-pointer shrink-0">ค้นหา</button>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading || isSaving || isLookingUp">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4 w-[56px]">
              <input type="checkbox" [checked]="allPageSelected" (change)="toggleSelectAllPage(($any($event.target)).checked)"
                [disabled]="!selectedSiteId || parkingCards.length === 0"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
            </th>
            <th class="p-4">ID</th>
            <th class="p-4">หมายเลขบัตร</th>
            <th class="p-4">ทะเบียนรถ</th>
            <th class="p-4">ประเภทรถ</th>
            <th class="p-4">Client</th>
            <th class="p-4">สมาชิก</th>
            <th class="p-4">วันเริ่มสิทธิ์</th>
            <th class="p-4">วันหมดอายุ</th>
            <th class="p-4 text-center">สถานะ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngIf="!selectedSiteId && !isLoading">
            <td colspan="10" class="py-16 text-center text-slate-400 font-bold">กรุณาเลือกลานจาก Sidebar</td>
          </tr>
          <tr *ngFor="let card of parkingCards; trackBy: trackById"
            class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40"
            [ngClass]="isSelected(card.id) ? 'bg-amber-50/40 dark:bg-amber-950/20' : ''">
            <td class="p-4">
              <input type="checkbox" [checked]="isSelected(card.id)"
                (change)="toggleRow(card.id, ($any($event.target)).checked)"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
            </td>
            <td class="p-4 font-mono text-slate-400">{{ card.id }}</td>
            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5 min-w-0">
                <span class="text-xs text-slate-500 dark:text-slate-400 truncate">{{ card.cardName || '—' }}</span>
                <span class="text-[11px] font-mono text-slate-400 dark:text-slate-500 truncate max-w-[14rem]"
                  [title]="card.cardCode || ''">{{ card.cardCode || '—' }}</span>
              </div>
            </td>
            <td class="p-4 font-mono text-sm text-slate-700 dark:text-slate-200">{{ plateOf(card) }}</td>
            <td class="p-4 text-xs font-bold">{{ card.vehicleTypeName || '—' }}</td>
            <td class="p-4">
              <span class="px-2.5 py-1 rounded-lg bg-sky-50 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400 text-xs font-bold">
                {{ card.clientName || '—' }}
              </span>
            </td>
            <td class="p-4 text-xs">{{ card.name || '—' }}</td>
            <td class="p-4 text-xs whitespace-nowrap">{{ card.issueDate | date:'dd/MM/yyyy' }}</td>
            <td class="p-4 text-xs whitespace-nowrap">{{ card.expireDate | date:'dd/MM/yyyy' }}</td>
            <td class="p-4 text-center">
              <span
                class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                [ngClass]="{
                  'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800': card.status === 1,
                  'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800': card.status === 0,
                  'bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-800': card.status === 2,
                  'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800': card.status === 3
                }">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5" [ngClass]="{
                  'bg-green-500': card.status === 1,
                  'bg-amber-500': card.status === 0,
                  'bg-rose-500': card.status === 2,
                  'bg-yellow-500': card.status === 3
                }"></span>
                {{ getStatusText(card.status) }}
              </span>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading && parkingCards.length === 0">
            <td colspan="10" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">ไม่พบข้อมูลบัตร</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="page === currentPage ? 'bg-amber-400 text-white' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Sticky action bar -->
<div *ngIf="selectedCount > 0 && canUpdate"
  class="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 px-5 py-3 rounded-2xl bg-slate-900/95 dark:bg-slate-100/95 text-white dark:text-slate-900 shadow-2xl border border-slate-700/50 dark:border-slate-300/50">
  <span class="text-sm font-bold whitespace-nowrap">เลือก {{ selectedCount | number }} ใบ</span>
  <button type="button" (click)="clearSelection()"
    class="px-3 py-2 rounded-xl text-xs font-bold opacity-80 hover:opacity-100 cursor-pointer">ล้าง</button>
  <button type="button" (click)="openEditModal('dates')" [disabled]="isSaving"
    class="px-3 py-2 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-xs font-bold disabled:opacity-50 cursor-pointer">แก้วันที่</button>
  <button type="button" (click)="openEditModal('subscription')" [disabled]="isSaving"
    class="px-3 py-2 rounded-xl bg-sky-400 hover:bg-sky-500 text-slate-900 text-xs font-bold disabled:opacity-50 cursor-pointer">แก้ Subscription</button>
  <button type="button" (click)="openEditModal('client')" [disabled]="isSaving"
    class="px-3 py-2 rounded-xl bg-emerald-400 hover:bg-emerald-500 text-slate-900 text-xs font-bold disabled:opacity-50 cursor-pointer">แก้ Client</button>
</div>

<!-- Edit modal -->
<div *ngIf="isEditModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm"
  (click)="closeEditModal()">
  <div class="w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-[1.75rem] bg-white dark:bg-slate-800 shadow-2xl border border-slate-100 dark:border-slate-700"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-700 flex items-start justify-between gap-3">
      <div>
        <h3 class="text-xl font-extrabold text-slate-800 dark:text-slate-100">{{ editModalTitle }}</h3>
        <p class="text-xs text-slate-400 mt-1 font-medium">กำลังแก้ <strong class="text-amber-600">{{ editScopeCount | number }}</strong> ใบ</p>
      </div>
      <button type="button" (click)="closeEditModal()"
        class="w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-400 hover:text-slate-600 cursor-pointer">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <div class="p-6 space-y-5">
      <div *ngIf="editMode === 'dates'" class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1.5">วันเริ่มสิทธิ์</label>
          <div class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 h-[42px]">
            <div class="relative flex-1 h-full flex items-center">
              <div class="absolute inset-0 flex items-center justify-between px-1 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ editIssueDate ? (editIssueDate | date:'dd/MM/yyyy') : 'เลือกวันที่' }}</span>
              </div>
              <input #editIssuePicker type="date" [(ngModel)]="editIssueDate" [max]="editExpireDate || null"
                (click)="editIssuePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0" />
            </div>
          </div>
          <p class="mt-1 text-[11px] text-slate-400">เวลา 00:00</p>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1.5">วันหมดอายุ</label>
          <div class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 h-[42px]">
            <div class="relative flex-1 h-full flex items-center">
              <div class="absolute inset-0 flex items-center justify-between px-1 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ editExpireDate ? (editExpireDate | date:'dd/MM/yyyy') : 'เลือกวันที่' }}</span>
              </div>
              <input #editExpirePicker type="date" [(ngModel)]="editExpireDate" [min]="editIssueDate || null"
                (click)="editExpirePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0" />
            </div>
          </div>
          <p class="mt-1 text-[11px] text-slate-400">เวลา 23:59</p>
        </div>
      </div>

      <div *ngIf="editMode === 'subscription'">
        <p *ngIf="singleVehicleTypeInScope" class="text-xs text-slate-400 mb-2">
          แสดง Subscription สำหรับประเภทรถในกลุ่มที่แก้ไข
        </p>
        <select [(ngModel)]="editSubscriptionId"
          class="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 text-sm font-bold outline-none focus:ring-2 focus:ring-amber-200">
          <option [ngValue]="0">— เลือก Subscription —</option>
          <option *ngFor="let s of subscriptionsForEdit" [ngValue]="s.id">{{ s.name }}</option>
        </select>
      </div>

      <div *ngIf="editMode === 'client'" class="relative">
        <input type="text" [(ngModel)]="editClientSearchText"
          (focus)="isEditClientDropdownOpen = true"
          (ngModelChange)="isEditClientDropdownOpen = true"
          placeholder="ค้นหาหรือเลือก Client..."
          class="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
        <div *ngIf="isEditClientDropdownOpen"
          class="absolute z-30 mt-1 w-full max-h-48 overflow-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg"
          (mousedown)="$event.preventDefault()">
          <button type="button" (click)="clearEditClient()"
            class="w-full text-left px-4 py-2 text-xs font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer">ล้าง</button>
          <button type="button" *ngFor="let c of editClientOptions" (click)="selectEditClient(c)"
            class="w-full text-left px-4 py-2 text-sm hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer">{{ c.name }}</button>
        </div>
      </div>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col-reverse sm:flex-row justify-end gap-3">
      <button type="button" (click)="closeEditModal()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold cursor-pointer">
        ยกเลิก
      </button>
      <button type="button" (click)="onEditModalSave()" [disabled]="isSaving"
        class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold disabled:opacity-50 cursor-pointer inline-flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">save</span>
        บันทึก
      </button>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="isConfirmModalOpen"
  [title]="confirmTitle"
  [message]="'อัปเดตบัตร'"
  [highlight]="confirmHighlight"
  [messageSuffix]="confirmMessageSuffix"
  confirmLabel="ยืนยันบันทึก"
  cancelLabel="ยกเลิก"
  [icon]="editMode === 'dates' ? 'event' : (editMode === 'subscription' ? 'card_membership' : 'business')"
  variant="warning"
  [showIrreversibleNote]="true"
  (confirm)="confirmSave()"
  (cancel)="closeConfirmModal()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading || isSaving || isLookingUp"></app-pss-loading>
